import { FormControl, InputLabel, Select, SelectProps } from '@material-ui/core'
import React from 'react'
import { Control, Controller, FieldName, FieldValues } from 'react-hook-form'
import { IoMdArrowDropdown } from 'react-icons/io'

interface IProps<T extends FieldValues> extends SelectProps {
  children?: React.ReactNode
  control: Control<T>
  'data-e2e'?: string
  defaultValue?: string
  error?: boolean
  id: string
  label?: string
  variant?: 'standard' | 'outlined' | 'filled'
  required?: boolean
}

const FormSelect = <TFieldValues extends FieldValues>({
  children,
  error,
  id,
  label,
  control,
  defaultValue,
  variant,
  required,
  ...rest
}: IProps<TFieldValues>) => {
  const labelId = `${id}-label`
  return (
    <FormControl error={error} fullWidth variant={variant}>
      {label && <InputLabel id={labelId}>{label}</InputLabel>}
      <Controller
        control={control}
        defaultValue={defaultValue}
        name={id as FieldName<TFieldValues>}
        rules={{ required }}
        render={({ value, onChange }) => (
          <Select
            data-e2e={rest['data-e2e']}
            id={id}
            label={label}
            labelId={labelId}
            IconComponent={IoMdArrowDropdown}
            value={value}
            onChange={onChange}
          >
            {children}
          </Select>
        )}
      />
    </FormControl>
  )
}

export default FormSelect
